import {EaType} from "@t/customer/EAddress";

export interface EAMeta {
    icon: string,
    type: number,
    ok: boolean,
    empty: boolean,
    href?: string,
	/** Target for href link */
	target?: string,
    value: string,
    raw?: string
}


function startsWithProtocolName(url:string|null):boolean {
    if (url === null) return false;
    const u = url.toLowerCase();
    return u.startsWith("http://") || u.startsWith("https://") || u.startsWith("ftp://");
}

function completeUrl(url:string):string {
    let lcUrl = url.toLowerCase();
    if (
        lcUrl.startsWith("http:") ||
        lcUrl.startsWith("https:") ||
        lcUrl.startsWith("ftp:") ||
        lcUrl.startsWith("file:") ||
        lcUrl.startsWith("mailto:") ||
        lcUrl.startsWith("tel:") ||
        lcUrl.startsWith("//")
    ) {
        return url;
    }
    return "https://" + url;
}

function checkKnownSocialNetworks(meta:EAMeta):void {
    if (!meta.href) return;
    try {
        const url = new URL(meta.href);
        const host = url.host.toLowerCase();
        if (host.indexOf("twitter.com") >= 0 || host === "x.com") {
            meta.icon = "x";
            meta.type = EaType.TWITTER;
        } else if (host.indexOf("youtube.com") >= 0 || host.indexOf("youtu.be") >= 0) {
            meta.icon = "youtube";
            meta.type = EaType.YOUTUBE;
        } else if (host.indexOf("facebook.com") >= 0) {
            meta.icon = "facebook";
            meta.type = EaType.FACEBOOK;
        } else if (host.indexOf("linkedin.com") >= 0) {
            meta.icon = "linkedin";
            meta.type = EaType.LINKEDIN;
        } else if (host.indexOf("instagram.com") >= 0) {
            meta.icon = "instagram";
            meta.type = EaType.INSTAGRAM;
        } else if (host.indexOf("tiktok.com") >= 0) {
            meta.icon = "tiktok";
            meta.type = EaType.TIKTOK;
        } else if (host.indexOf("pinterest.com") >= 0) {
            meta.icon = "pinterest";
            meta.type = EaType.PINTEREST;
        }
    } catch (e) { /* invalid url */ }
}


export default function(ea?:string|null, rawEa?:string):EAMeta {
    const PHONE_REGEX = /^\+?[0-9/()\-\s]{5,20}((#|ext\.?|kl\.?|x|;)\s*(\d{1,10}))?$/;
    const EMAIL_REGEX =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const HOST_REGEX = /^([a-z0-9][a-z0-9\-_]*\.)+[a-z]{2,8}$/gi;
    const NOSTR_REGEX = /(npub|nsec|comment|nprofile|nevent|nrelay|naddr)1([qpzry9x8gf2tvdw0s3jn54khce6mua7l]+)/i;

    let data = ea == null ? "" : ea.trim();

    let type = "UNKNOWN";
    if (data.length === 0) type = "EMPTY";
    else if (PHONE_REGEX.test(data)) type = "PHONE";
    else if (EMAIL_REGEX.test(data)) type = "EMAIL";
    else if (startsWithProtocolName(data) || HOST_REGEX.test(data)) type = "WEB";
    else if (NOSTR_REGEX.test(data)) type = "NOSTR";

    const meta:EAMeta = {
        icon: "phone",
        type: EaType.UNKNOWN,
        ok: true,
        empty: false,
        value: ea ? ea : "",
        raw: rawEa ? rawEa : ""
    };

    switch (type) {
        case "PHONE":
            meta.type = EaType.PHONE;
            meta.icon = "phone";
            meta.href = "tel:" + encodeURIComponent(data);
            break;
        case "EMAIL":
            meta.type = EaType.EMAIL;
            meta.icon = "email";
            meta.href = "mailto:" + data;
            break;
        case "WEB":
            meta.href = completeUrl(data);
			meta.target = "_blank";
            meta.type = EaType.WEB;
            meta.icon = "web";
            checkKnownSocialNetworks(meta);
            break;
        case "NOSTR":
            meta.type = EaType.NOSTR;
            meta.icon = "nostr";
            break;
        case "UNKNOWN":
            meta.icon = "warning-18-bold";
            meta.ok = false;
            break;
        case "EMPTY":
            meta.empty = true;
    }
    return meta as EAMeta;
}
